import {Component, Input, OnInit} from '@angular/core';
import {LinkedDepartmentsLinkType} from '../../../../shared-utilities/models-old/datastructures';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';

export interface DepInfo {
  depId: string;
  name: string;
}

export interface SuggestedLink {
  storeA: DepInfo;
  storeB: DepInfo;
}

@Component({
  selector: 'app-unlinked-departments-modal',
  templateUrl: './unlinked-departments-modal.component.html',
  styleUrls: ['./unlinked-departments-modal.component.scss'],
  standalone: false,
})
export class UnlinkedDepartmentsModalComponent implements OnInit {
  @Input() type: LinkedDepartmentsLinkType;
  @Input() suggestLinks: SuggestedLink[];
  @Input() storeABIDs: {storeA: string; storeB: string};
  @Input() noLinks?: string[];

  // @Output() updateDepartments = new EventEmitter<{ [storeId: string]: DepInfo }[]>();

  confirmedLinks: Record<string, DepInfo>[];

  typeText: string;


  constructor(
    private modalController: ModalControllerService,
  ) {
  }

  ngOnInit(): void {
    if (this.type === 'dep') {
      this.typeText = 'Department';
    } else if (this.type === 'sub') {
      this.typeText = 'Sub-Department';
    }
  }

  async addDepartment(i: number): Promise<void> {
    const suggestion = this.suggestLinks[i];
    this.confirmedLinks.push({
      [this.storeABIDs.storeA]: suggestion.storeA,
      [this.storeABIDs.storeB]: suggestion.storeB,
    });
    await this.removeDepartmentFromView(i);
  }

  async removeDepartmentFromView(i: number): Promise<void> {
    this.suggestLinks.splice(i, 1);
    if (this.suggestLinks.length === 0) {
      await this.submit();
    }
  }

  async submit(): Promise<void> {
    await this.modalController.dismiss(this.confirmedLinks).then();
  }

  async closeModal(): Promise<void> {
    await this.modalController.dismiss().then();
  }

  trackBySuggestion(_: number, item: SuggestedLink): string {
    return `${item.storeA.depId}-${item.storeB.depId}`;
  }
}
